export default __webpack_public_path__ + "static/media/unacceptable-photo-no-hats-allowed.06e82beb.png";